export const funnelEvents = {
  start: 'START',
  questionMachineReady: 'QUESTION_MACHINE_READY',
  accordionToggle: 'ACCORDION_TOGGLE',
  accordionClose: 'ACCORDION_CLOSE'
}

export const questionEvents = {
  updateAnswer: 'UPDATE_ANSWER',
  updateActorAnswers: 'UPDATE_ACTOR_ANSWERS',
  updatePopupURL: 'UPDATE_POPUP_URL',
  valid: 'VALID',
  invalid: 'INVALID',
  next: 'NEXT',
  nextQuestionGroup: 'NEXT_QUESTION_GROUP',
  startAutoNav: 'START_AUTONAV',
  exitAutoNav: 'EXIT_AUTONAV',
  prev: 'PREV',
  authSuccess: 'AUTH_SUCCESS',
  authFailure: 'AUTH_FAILURE',
  finalizeComplete: 'FINALIZE_COMPLETE',
  finalizeError: 'FINALIZE_ERROR'
}

export const inputEvents = {
  validate: 'VALIDATE',
  startValidation: 'START_VALIDATION',
  change: 'CHANGE',
  toggle: 'TOGGLE',
  blur: 'BLUR',
  focus: 'FOCUS',
  select: 'SELECT',
  deselect: 'DESELECT'
}

export const broadcastEvents = {
  questionResponse: 'QUESTION_RESPONSE',
  nextButtonClick: 'NEXT_BUTTON_CLICK',
  backButtonClick: 'BACK_BUTTON_CLICK',
  submitButtonClick: 'SUBMIT_BUTTON_CLICK',
  accordionToggle: 'ACCORDION_TOGGLE',
  checkboxToggle: 'CHECKBOX_TOGGLE',
  funnelStart: 'FUNNEL_START',
  funnelFinalize: 'FUNNEL_FINALIZE',
  funnelDone: 'FUNNEL_DONE',
  configError: 'CONFIG_ERROR',
  changeConfig: 'CHANGE_CONFIG',
  authSuccess: 'AUTH_SUCCESS',
  authFailure: 'AUTH_FAILURE'
}
